import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = {
  key: 0,
  class: "table-summary"
}
const _hoisted_4 = { class: "color-error" }
const _hoisted_5 = { class: "color-error" }

import { getCurrentInstance, onMounted, reactive, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { getCouponListApi, bindUserCouponApi, unbindUserCouponApi, changeCouponStatusToUsedApi } from '@/apis/marketing'
import Pagination from '@/components/Pagination.vue'
import { updateCouponDelayApi } from '@/apis/coupon'
import { useStore } from '@/store/index'
import { downloadFile } from '@/utils'
import { CouponType } from './enum'


export default /*@__PURE__*/_defineComponent({
  __name: 'CouponList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const store = useStore()
const route = useRoute()

const coupon_id = route.query.coupon_id as string
const coupon_no = route.query.coupon_no as string || ''
const user_coupon_id = route.query.user_coupon_id as string || ''
const is_test = ref(0) // 当前券包是否为测试券包
const checked_count = ref(0) // 已核销数量-仅针对测试券包
const coupon_type = ref(0) // 券类型

// 查询参数
const filters = reactive({
  coupon_id: coupon_id,
  valid_from: '',
  valid_to: '',
  coupon_no: coupon_no,
  status: '',
  username: '',
  user_coupon_id: user_coupon_id,
  is_owner_not_null: false,
  page_size: 10,
  page: 1,
})

// 获取列表数据
const tableData = ref([])
const total = ref(0)
const getList = async () => {
  const { code, data, msg } = await getCouponListApi(filters) as any
  if (code == 200) {
    tableData.value = data.data || []
    total.value = data.total
    is_test.value = data.is_test
    checked_count.value = data.verifications_count
    coupon_type.value = data.type
  } else {
    proxy.$message({ type: 'error', message: msg || '获取列表失败' })
  }
}

// 响应式数据
const generateLoading = ref(false)
const selectedRows = ref<any[]>([])
const delayModalVisible = ref(false)
const unbindModalVisible = ref(false)
const usedModalVisible = ref(false)

// 延期表单
const delayForm = ref({
  couponId: '',
  delayDays: null as number | null,
  delayDate: ''
})

// 改为已使用表单
const usedForm = ref({
  user_coupon_id: '',
  msg: ''
})

// 券包信息
const couponInfo = ref({
  id: '',
  type: '',
  coupon_status: 0
})

// 有效期范围
const validRange = computed({
  get() {
    if (filters.valid_from && filters.valid_to) {
      return [filters.valid_from, filters.valid_to];
    }
    return [];
  },
  set(val: any) {
    if (val && val.length == 2) {
      filters.valid_from = val[0];
      filters.valid_to = val[1];
    } else {
      filters.valid_from = '';
      filters.valid_to = '';
    }
  }
});

// 计算属性 - 是否显示生成按钮
const showGenerateButton = computed(() => {
  return couponInfo.value.type != '1' || (couponInfo.value.type == '1' && couponInfo.value.coupon_status == 1);
})

// 处理查询
const handleQuery = () => {
  filters.page = 1
  getList()
}

const onPageChange = (val: number) => {
  filters.page = val
  getList()
}

const onSizeChange = (val: number) => {
  filters.page_size = val
  getList()
}

// 处理导入券码
const handleImportCodes = () => {
  const couponId = couponInfo.value.id
  window.open(`/admin/user_coupon/import_form?coupon_id=${couponId}`, '_blank')
}

// 处理生成
const handleGenerate = async () => {
  generateLoading.value = true
  try {
    // 这里需要调用生成券码的API
    proxy.$message({ type: 'success', message: '生成成功' })
    getList() // 刷新列表
  } catch (error) {
    console.error('生成失败:', error)
    proxy.$message({ type: 'error', message: '生成失败' })
  } finally {
    generateLoading.value = false
  }
}

// 处理导出
const onExport = () => {
  downloadFile('/opsapi/userCouponsExport', {coupon_id})
}

// 处理批量绑定
const handleBatchBind = () => {
  const couponId = route.query.coupon_id as string || ''
  window.open(`/admin/user_coupon/bind_coupon_new?coupon_id=${couponId}`, '_blank')
}

// 处理渠道扒券
const handleChannelCoupons = () => {
  const couponId = route.query.coupon_id as string || ''
  window.open(`/admin/user_coupon/get_channel_coupons?coupon_id=${couponId}`, '_blank')
}

// 处理多选变化
const handleSelectionChange = (selection: any[]) => {
  selectedRows.value = selection
}

// 遮盖券号
const maskCouponNo = (couponNo: string) => {
  if (!couponNo) return ''
  const len = couponNo.length
  if (len >= 4) {
    return couponNo.substring(0, 2) + '****' + couponNo.substring(len - 2)
  } else {
    return couponNo.substring(0, 2) + '**'
  }
}

// 获取券状态文本
const getCouponStatusText = (status: number) => {
  const statusMap: Record<string, string> = {
    '0': '未使用',
    '1': '已使用',
    '-1': '已作废',
    '-4': '待激活',
    '-5': '未激活'
  }
  return statusMap[status.toString()] || '未知状态'
}

// 判断是否可以改为已使用
const canChangeToUsed = (row: any) => {
  return row.type == '1' && // 门店券
         row.owner_id && // 已绑定
         row.status == 0 && // 未使用
         row.coupon_status == 0 // 采购
}

// 判断是否可以改为未使用
const canChangeToUnused = (row: any) => {
  return row.status == 1 && 
         row.type == '1' && 
         row.owner_id > 0 &&
         // 这里应该根据当前用户的权限来判断，暂时简化处理
         true
}

// 处理查看
const handleView = (row: any) => {
  window.open(`/admin/user_coupon/bind_coupon?is_view=1&user_coupon_id=${row.id}`, '_blank')
}

// 处理绑定
const bindDialogVisible = ref(false)
const rowData = ref<any>({})
const handleBind = (row: any) => {
  Object.assign(rowData.value, row)
  bindDialogVisible.value = true
}
const handleBindSubmit = async () => {
  if (!rowData.value.username) {
    proxy.$message({ type: 'warning', message: '请填写用户名' })
    return
  }
  if (!rowData.value.msg) {
    proxy.$message({ type: 'warning', message: '请填写赠券说明' })
    return
  }

  const { id:user_coupon_id, username, msg } = rowData.value
  const { code, data, msg:resMsg } = await bindUserCouponApi({ user_coupon_id, username, msg }) as any
  if (code != 200) return proxy.$message({ type: 'error', message: resMsg })

  proxy.$message({ type: 'success', message: '绑定成功' })
  bindDialogVisible.value = false
  getList()
}
const handleBindClose = () => {
  bindDialogVisible.value = false
}

// 处理解绑
const unbindDialogVisible = ref(false)
const handleUnbind = (row: any) => {
  Object.assign(rowData.value, row)
  unbindDialogVisible.value = true
}
const handleUnbindSubmit = async () => {
  if (!rowData.value.msg) {
    proxy.$message({ type: 'warning', message: '请填写解绑原因' })
    return
  }
  
  const { id:user_coupon_id, owner_id, reason:msg } = rowData.value
  const { code, data, msg:resMsg } = await unbindUserCouponApi({ user_coupon_id, owner_id, msg }) as any
  if (code != 200) return proxy.$message({ type: 'error', message: resMsg })

  proxy.$message({ type: 'success', message: '解绑成功' })
  unbindModalVisible.value = false
  getList() // 刷新列表
}
const handleUnbindClose = () => {
  unbindDialogVisible.value = false
}

// 处理改为已使用
const handleChangeToUsed = (row: any) => {
  usedForm.value.user_coupon_id = row.id.toString()
  usedForm.value.msg = ''
  usedModalVisible.value = true
}

// 处理延期
const handleDelay = (row: any, type: 'card' | 'general') => {
  delayForm.value.couponId = row.id.toString()
  delayForm.value.delayDays = null
  delayForm.value.delayDate = ''
  delayModalVisible.value = true
}

// 处理改为未使用
const handleChangeToUnused = async (row: any) => {
  try {
    await proxy.$confirm('确定要改为未使用？', '确认操作', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    
    // 这里需要调用改为未使用的API
    proxy.$message({ type: 'success', message: '操作成功' })
    getList() // 刷新列表
  } catch (error) {
    // 用户取消操作
  }
}

// 提交延期
const handleDelaySubmit = async () => {
  if (!delayForm.value.delayDays && !delayForm.value.delayDate) {
    proxy.$message({ type: 'warning', message: '请填写延长天数或延长有效期' })
    return
  }
  
  if (delayForm.value.delayDays && delayForm.value.delayDate) {
    proxy.$message({ type: 'warning', message: '延长天数和有效期仅能填写一项' })
    return
  }
  
  const { code, data, msg } = await updateCouponDelayApi(delayForm.value.couponId, delayForm.value.delayDays || delayForm.value.delayDate) as any
  if (code != 200) return proxy.$message({ type: 'error', message: msg })
  proxy.$message({ type: 'success', message: '延期成功' })
  delayModalVisible.value = false
  getList() // 刷新列表
}

// 提交改为已使用
const handleUsedSubmit = async () => {
  if (!usedForm.value.msg.trim()) {
    proxy.$message({ type: 'warning', message: '请填写原因' })
    return
  }
  
  const { code, data, msg } = await changeCouponStatusToUsedApi(usedForm.value.user_coupon_id, usedForm.value.msg) as any
  if (code != 200) return proxy.$message({ type: 'error', message: msg })
  proxy.$message({ type: 'success', message: '操作成功' })
  usedModalVisible.value = false
  getList() // 刷新列表
}

// 处理选中项作废
const handleInvalidateSelected = async () => {
  if (selectedRows.value.length == 0) {
    proxy.$message({ type: 'warning', message: '请先选择要作废的券' })
    return
  }
  
  try {
    await proxy.$confirm('确定作废选中的券吗?', '确认操作', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    
    // 这里需要调用作废API
    proxy.$message({ type: 'success', message: '作废成功' })
    getList() // 刷新列表
  } catch (error) {
    // 用户取消操作
  }
}

// 处理未绑定作废
const handleInvalidateUnbind = async () => {
  const couponId = route.query.coupon_id as string || ''
  
  try {
    await proxy.$confirm('未绑定的确定全部作废吗?', '确认操作', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    
    // 这里需要调用未绑定作废API
    proxy.$message({ type: 'success', message: '作废成功' })
    getList() // 刷新列表
  } catch (error) {
    // 用户取消操作
  }
}

// 初始化
onMounted(() => {
  // 获取路由参数中的券包信息
  const couponId = route.query.coupon_id as string || ''
  // 这里应该根据券包ID获取券包详细信息
  // 为了简化，我们暂时设置一些默认值
  couponInfo.value = {
    id: couponId,
    type: '1', // 示例值
    coupon_status: 1 // 示例值
  }
  
  getList()
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_integer = _resolveDirective("integer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_unref(CouponType)[coupon_type.value] == '门店券' && _unref(coupon_id) && is_test.value == 1)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "filter-btn",
            type: "primary",
            onClick: onExport
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    (_unref(coupon_id))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[17] || (_cache[17] = _createTextVNode("券码总计 ")),
          _createElementVNode("b", _hoisted_4, _toDisplayString(total.value), 1),
          _createTextVNode(" ，" + _toDisplayString(_unref(CouponType)[coupon_type.value] == '门店券' ? '已核销' : '已使用') + " ", 1),
          _createElementVNode("b", _hoisted_5, _toDisplayString(checked_count.value), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_name",
          label: "礼券",
          "min-width": "150"
        }),
        _createVNode(_component_el_table_column, {
          prop: "coupon_id",
          label: "券包ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "券号",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(maskCouponNo(row.coupon_no)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "owner_id",
          label: "用户ID",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          prop: "username",
          label: "用户名",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "amount",
          label: "面值金额",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          width: "100"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(getCouponStatusText(row.status)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "sale_channel",
          label: "销售渠道",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "salesman_name",
          label: "销售人员",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "有效期",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.valid_from) + " 至 " + _toDisplayString(row.valid_to), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "绑卡有效期",
          width: "200"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.bind_from) + " 至 " + _toDisplayString(row.bind_to), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "shop_name",
          label: "核销门店",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "核销时间",
          width: "140"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "150",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              link: "",
              onClick: ($event: any) => (handleChangeToUsed(row)),
              disabled: !canChangeToUsed(row),
              title: canChangeToUsed(row) ? '' : '仅针对已绑定且未使用采购类门店券生效'
            }, {
              default: _withCtx(() => _cache[18] || (_cache[18] = [
                _createTextVNode(" 改为已使用 ")
              ])),
              _: 2
            }, 1032, ["onClick", "disabled", "title"]),
            (row.type == '3')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  link: "",
                  onClick: ($event: any) => (handleDelay(row, 'card'))
                }, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("卡券延期")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true),
            (row.type == '1')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "primary",
                  link: "",
                  onClick: ($event: any) => (handleDelay(row, 'general'))
                }, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("延期")
                  ])),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    _createVNode(_component_el_dialog, {
      modelValue: delayModalVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((delayModalVisible).value = $event)),
      title: "券延期",
      width: "600px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (delayModalVisible.value = false))
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleDelaySubmit
        }, {
          default: _withCtx(() => _cache[22] || (_cache[22] = [
            _createTextVNode("确认")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: delayForm.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "延长天数" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_el_input, {
                  modelValue: delayForm.value.delayDays,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((delayForm.value.delayDays) = $event)),
                  min: 0,
                  placeholder: "请填写延长天数"
                }, null, 8, ["modelValue"]), [
                  [_directive_integer]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "或" }),
            _createVNode(_component_el_form_item, { label: "有效至" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: delayForm.value.delayDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((delayForm.value.delayDate) = $event)),
                  type: "date",
                  placeholder: "选择日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: usedModalVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((usedModalVisible).value = $event)),
      title: "改为已使用"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (usedModalVisible.value = false))
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleUsedSubmit
        }, {
          default: _withCtx(() => _cache[24] || (_cache[24] = [
            _createTextVNode("确认")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: usedForm.value,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "原因" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: usedForm.value.msg,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((usedForm.value.msg) = $event)),
                  type: "textarea",
                  placeholder: "请填写原因"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: bindDialogVisible.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((bindDialogVisible).value = $event)),
      title: "绑定用户",
      "before-close": handleBindClose,
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: handleBindClose }, {
          default: _withCtx(() => _cache[25] || (_cache[25] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleBindSubmit
        }, {
          default: _withCtx(() => _cache[26] || (_cache[26] = [
            _createTextVNode("确认")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: rowData.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "礼券名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.coupon_name,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rowData.value.coupon_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "用户名" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.username,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((rowData.value.username) = $event)),
                  modelModifiers: { trim: true }
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "赠券说明" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.msg,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((rowData.value.msg) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  rows: 4
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: unbindDialogVisible.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((unbindDialogVisible).value = $event)),
      title: "解除绑定",
      "before-close": handleUnbindClose,
      width: "500px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, { onClick: handleUnbindClose }, {
          default: _withCtx(() => _cache[27] || (_cache[27] = [
            _createTextVNode("取消")
          ])),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleUnbindSubmit
        }, {
          default: _withCtx(() => _cache[28] || (_cache[28] = [
            _createTextVNode("确认")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: rowData.value,
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "礼券名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.coupon_name,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((rowData.value.coupon_name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "绑定用户ID" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.owner_id,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((rowData.value.owner_id) = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "绑定用户名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.username,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((rowData.value.username) = $event)),
                  modelModifiers: { trim: true },
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "解绑说明" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: rowData.value.reason,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((rowData.value.reason) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  rows: 4
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})